import { axios } from '@/services/axios';

const updateServiceDefinition = async (payload, wholesalerID, scope) => {
    const response = await axios.put(
        `/ServiceProfile/OperatorPlatform/Wholesaler/${wholesalerID}/ServiceDefinition`,
        payload,
        {
            headers: {
                'X-RequestScope': scope,
            },
        },
    );
    return response;
};

export default updateServiceDefinition;
